module.exports = __webpack_public_path__ + "img/32.07fb1746.png";